import clsx from "clsx";

// `tone` is the surface the tab bar sits on: "default" for the page/card background,
// "onBrand" for the blue header band that pages overlap via Layout's -mt-32. Gray text
// on that band is unreadable, which is why the tone is explicit rather than inferred.
const TONE_CLASSES = {
  default: {
    bar: "border-gray-200 dark:border-gray-700",
    active: "border-sky-600 dark:border-sky-400 text-sky-700 dark:text-sky-400",
    inactive:
      "border-transparent text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 hover:border-gray-300 dark:hover:border-gray-600",
  },
  onBrand: {
    bar: "border-white/25",
    active: "border-white text-white",
    inactive: "border-transparent text-white hover:border-white/50",
  },
};

export default function Tabs({ tabs, value, onChange, tone = "default", className }) {
  const t = TONE_CLASSES[tone] ?? TONE_CLASSES.default;
  return (
    <div className={clsx("border-b mb-6", t.bar, className)}>
      <nav className="-mb-px flex space-x-6">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => onChange(tab.id)}
            className={clsx(
              "whitespace-nowrap border-b-2 py-3 px-1 text-sm font-medium transition-colors",
              value === tab.id ? t.active : t.inactive
            )}
          >
            {tab.label}
          </button>
        ))}
      </nav>
    </div>
  );
}
